import React from 'react';
import { Button, Radio, RadioChangeEvent, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const { Search } = Input;
import s from './Filters.module.scss';

export const Filters = ({
  handleSearch,
  setActive,
  redirectToRedactor,
}: {
  handleSearch: (e: string) => void;
  setActive: (e: string) => void;
  redirectToRedactor: (e: string) => void;
}) => {
  const onChange = (e: RadioChangeEvent) => {
    setActive(e.target.value);
  };
  const onSearch = (e) => {
    const value = e.target.value;
    handleSearch(value);
  };

  return (
    <div className={s.Filters}>
      <div className={s.leftZone}>
        <Radio.Group onChange={onChange} defaultValue='active'>
          <Radio.Button value={'Active, Draft'}>Активные</Radio.Button>
          <Radio.Button value={'Archive'}>Архив</Radio.Button>
        </Radio.Group>
      </div>

      <div className={s.rightZpne}>
        <Search
          placeholder='Найти'
          onChange={onSearch}
          style={{ width: '264px', marginRight: '16px' }}
        />

        <Button onClick={() => redirectToRedactor('')} type='primary' icon={<PlusOutlined />}>
          Создать
        </Button>
      </div>
    </div>
  );
};
